import { ActionType, LoginResponse } from './types';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import AuthService from '../AuthService';

interface LoginPayload {
  username: string,
  password: string
}

const actions = {
  logout: createAction(ActionType.LOGOUT),
  login: createAsyncThunk<LoginResponse, LoginPayload>(
    ActionType.LOGIN,
    async (payload) => {
      const response = await AuthService.login(payload.username, payload.password);
      return response;
    } 
  )
};

export default actions;
